import { ModelSelect } from 'vue-search-select';
import appStrings from '@/app/utility/string.utility';
import OrganizationList from '../../../../admin/organization';
export default {
  name: 'FmsMasterProjDetails',
  components: {
    ModelSelect,
    OrganizationList
  },
  data() {
    return {
      unsubscribe: null,
      showSelectedProjectRecord: false,
      showValueSetModal: false,
      orgType: null,
      openOuModal: false,
      loader: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      editMode: false,
      updateMode: false,
      crmMasterProj: {
        value: null,
        text: null
      },
      legalEntity: {
        value: null,
        text: null
      },
      fmsMasterProjName: null,
      fmsMasterProjCode: null,
      fmsMasterProjId: null,
      defaultValue: {
        text: null,
        value: null
      }
    };
  },
  mounted() {
    this.eventBus.$off('showRecordDetails');
    this.eventBus.$on('showRecordDetails', recordDetails => {
      this.fmsMasterProjCode = recordDetails.fms_master_prj_code;
      this.fmsMasterProjId = recordDetails.fms_master_prj_id;
      this.fmsMasterProjName = recordDetails.fms_master_prj_name;
      (this.crmMasterProj = {
        value: recordDetails.crm_master_prj_id,
        text: recordDetails.crm_master_prj_name
      }),
        (this.legalEntity = {
          value: recordDetails.le_id,
          text: recordDetails.org_name
        });
    });
    this.eventBus.$off('addCase');
    this.eventBus.$on('addCase', editMode => {
      this.updateMode = editMode;
    });
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          this.addAndEditMasterProject();
        }
        if (actionName === 'update') {
          this.updateMode = true;
        }
        if (actionName === 'upload') {
          this.eventBus.$emit('commonUpload', { id: this.fmsMasterProjId });
        }
      }
    });
  },
  methods: {
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.legalEntity = {
          value: item.org_id,
          text: item.org_name
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.CRM_MASTER_PROJECT) {
        this.crmMasterProj = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
      }
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    addAndEditMasterProject() {
      const payload = {
        crm_master_prj_id: this.crmMasterProj.value,
        fms_master_prj_code: this.fmsMasterProjCode,
        fms_master_prj_id: this.fmsMasterProjId,
        fms_master_prj_name: this.fmsMasterProjName,
        le_id: this.legalEntity.value
      };
      this.$store
        .dispatch('unitInventory/addAndEditMasterProject', payload)
        .then(response => {
          this.$emit('updateList');
          this.updateMode = false;
          if (response.status === 200) {
            this.loader = false;
            this.showAlert = true;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
          } else {
            this.loader = false;
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(err => {
          this.err = err;
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === this.legalEntity.value) {
        this.legalEntity = this.defaultValue;
      } else if (vsetCode === this.crmMasterProj.value) {
        this.crmMasterProj = this.defaultValue;
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
